import {Component, OnInit} from '@angular/core';

import {AlertService} from '../_services/index';

@Component({
  moduleId: module.id.toString(),
  selector: 'app-alert',
  templateUrl: 'alert.component.html'
})

export class AlertComponent implements OnInit {
  message: any;
  AlertWarning;

  constructor(private alertService: AlertService) {
  }

  ngOnInit(): void {
    this.AlertWarning = '../assets/images/danger1.png';
    this.alertService.getMessage().subscribe(message => {
      this.message = message;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/_directives/alert.component.ts